/**
 * @module
 * simple polyfill to swap the currentSrc of an object-fit'ed img to be the background of it's container.
 */
 
const selector = '[data-js-table-wrap]';
const tableWrap = function(el, app) {

    const wrap = el;
    const $wrap = $(wrap);
    const leftIndicator = $wrap.find('tr th:first-child')[0];
    // backup
    if (!leftIndicator) {
        const leftIndicator = $wrap.find('tr td:first-child')[0];
    }
    const rightIndicator = $wrap.find('tr th:last-child')[0];
    // backup
    if (!rightIndicator) {
        const rightIndicator = $wrap.find('tr td:last-child')[0];
    }
    
    const init = function() {

        $wrap.wrap( "<div class='Ge-Table-Wrap-Outer'></div>" );
        const $wrapOuter = $wrap.parent('.Ge-Table-Wrap-Outer');
        
        const options = {
            rootMargin: '0px',
            threshold: 0.95
        };
            
        if (rightIndicator) {
            const contentRight = function(entries, observer) { 
                entries.forEach(entry => {
                    if (entry.intersectionRatio < 0.95) {
                        $wrapOuter.addClass('Ge-Table-Wrap-Outer--content-right');
                    } else {
                        $wrapOuter.removeClass('Ge-Table-Wrap-Outer--content-right');
                    }
                });
            };
            const observerRight = new IntersectionObserver(contentRight, options);
            observerRight.observe(rightIndicator);
        }
        if (leftIndicator) {
            const contentLeft = function(entries, observer) { 
                entries.forEach(entry => {
                    if (entry.intersectionRatio < 0.95) {
                        $wrapOuter.addClass('Ge-Table-Wrap-Outer--content-left');
                    } else {
                        $wrapOuter.removeClass('Ge-Table-Wrap-Outer--content-left');
                    }
                });
            };
            const observerLeft = new IntersectionObserver(contentLeft, options);
            observerLeft.observe(leftIndicator);
        }

    };

    return {
        init: init()
    };
};

tableWrap.selector = selector;

export default tableWrap;
